import React from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CircleCheckboxInput from 'LuxKit/Checkbox/CircleCheckboxInput'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const Container = styled(Group)`
  box-shadow: inset 0 0 0 ${rem(1)} ${props => props.theme.palette.neutral.default.six};
  padding: ${rem(12)};
  border-radius: ${rem(12)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(16)} ${rem(20)};
  }
`
const ImagePlaceholder = styled(LoadingBox)`
  width: ${rem(42)};
  height: ${rem(42)};
`

const TextContainer = styled(Group)`
  flex: 1;
`

export function ReplaceItemCardSkeleton() {
  return (
    <Container direction="horizontal" horizontalAlign="space-between" gap={12} tabletGap={20} fullWidth>
      <ImagePlaceholder />
      <TextContainer direction="vertical" gap={12}>
        <TextLoadingBox typography="heading3" width="65%" />
        <TextLoadingBox typography="heading3" width="100%" />
      </TextContainer>
      <Group direction="vertical" verticalAlign="center">
        <CircleCheckboxInput disabled />
      </Group>
    </Container>
  )
}
